import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { HasPermission } from '../../authorization/components/HasPermission';
import { AppPermissions } from '../../authorization/Permissions';
import { ScriptManagementStores } from '../stores';
import { STORE_SCRIPT_MANAGEMENT } from '../stores/constants';
import ScriptManagementList from '../components/ScriptManagementList';

const ScriptManagementPage: React.FC<ScriptManagementStores> = ({ scriptManagementUI: store }) => {
    if (!store) {
        return null;
    }
    return (
        <HasPermission permissionClaim={AppPermissions.CanManageScripts}>
            <ScriptManagementList store={store} />
        </HasPermission>
    );
};

export default inject(STORE_SCRIPT_MANAGEMENT)(observer(ScriptManagementPage));
